import { render, staticRenderFns } from "./StockForm.vue?vue&type=template&id=1be6740c&scoped=true&"
import script from "./StockForm.vue?vue&type=script&lang=js&"
export * from "./StockForm.vue?vue&type=script&lang=js&"
import style0 from "./StockForm.vue?vue&type=style&index=0&id=1be6740c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be6740c",
  null
  
)

export default component.exports